function Loader() {
	return <p className="message">Loading...</p>;
}

export default Loader;
